import { PlusOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { Button, Spin } from "antd";
import { ColumnsType } from "antd/es/table";
import { useState } from "react";
import { BsPlusSquare } from "react-icons/bs";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { deleteMembership, listMembership } from "../../network/membership";
import { queryKeys } from "../../services/react-query/queryKeys";
import AntTable from "../AntTable/AntTable";
import MembershipRowData from "../AntTable/tableRowsData/MembershipRowData";
import HeadTable from "../GlobalTable/HeadTableD";
import SubInfo from "../admin/common/SubInfo";
import DeleteModal from "../common/DeleteModal";
import Empty from "../common/Empty";
import AddMembershipForm from "../membership/AddMembership";

const MembershipTable = () => {
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [dataDelete, setDataDelete] = useState({ id: null });
  const [editData, setEditData] = useState(0);
  const [activeModal, setActiveModal] = useState(null);
  const [search, setSearch] = useState("");
  const SearchInput = (e: any) => setSearch(e);

  const openModal = (modal: any) => {
    setActiveModal(modal);
  };

  const openEditModal = (modal: any, data: any) => {
    setActiveModal(modal);
    setEditData(data);
  };

  const closeModal = () => {
    setEditModal(false);
    setDeleteModal(false);
    setActiveModal(null);
    setEditData(0);
  };

  const showDeleteModal = (data: any) => {
    setDataDelete(data);
    setDeleteModal(true);
  };

  const modalComponents = {
    AddMembership: (
      <AddMembershipForm
        visible={true}
        onClose={closeModal}
        editMembershipData={editData}
      />
    ),

    EditMembership: (
      <AddMembershipForm
        visible={true}
        onClose={closeModal}
        editMembershipData={editData}
      />
    ),
  };
  const { locationId } = useSelector(
    (state: { calendar: { locationId: number | null } }) => state.calendar
  );
  const renderModal = activeModal ? modalComponents[activeModal] : null;

  const { data: listMemberships, isLoading } = useQuery(
    [queryKeys?.listMemberships, search],
    () => listMembership(locationId, search),
    {
      enabled: !!locationId,
    }
  );

  const columns: ColumnsType<any> = [
    {
      title: <FormattedMessage id="membership_name" />,
      dataIndex: "name",
      key: "name",
      render: (text: any) => (
        <div>
          <span className="capitalize text-color-primary"> {text}</span>
        </div>
      ),
    },
    {
      title: <FormattedMessage id="service_count" />,
      dataIndex: "number_sessions",
      key: "number_sessions",
      render: (text: any, record: any) => (
        <div className="text-[#9999A7] text-sm font-medium">
          <span className="mx-1 font-semibold text-[#9999A7]">
            {record?.pricing_option?.length}
          </span>
        </div>
      ),
    },

    {
      title: <FormattedMessage id="session_count" />,
      dataIndex: "sessions",
      key: "sessions",
      render: (text: any) => (
        <div className="text-[#9999A7] text-sm font-medium capitalize">
          <span className="mx-1 font-semibold text-[#9999A7]">{text}</span>
        </div>
      ),
    },
    {
      title: <FormattedMessage id="validity" />,
      dataIndex: "voucher_duration",
      key: "voucher_duration",
      render: (text: any, record: any) => (
        <div className="text-[#9999A7]">
          <span className="text-sm font-medium capitalize">
            {record?.voucher_duration?.name || (
              <FormattedMessage id={record?.expire_duration} />
            )}
          </span>
        </div>
      ),
    },
    {
      title: <FormattedMessage id="price" />,
      dataIndex: "number_sessions",
      key: "number_sessions",
      render: (text: any, record: any) => (
        <SubInfo
          value={record?.price}
          label={<FormattedMessage id="SARshort" />}
        />
      ),
    },
  ];
  const intl = useIntl();

  return (
    <div className="tabs p-6 bg-[#eef0ff]">
      {renderModal}
      <DeleteModal
        visible={deleteModal}
        onClose={closeModal}
        onDelete={deleteMembership}
        data={locationId}
        optionalParam2={dataDelete?.id}
        confirmationHeader={intl.formatMessage({
          id: "delete_membership_confirmation",
        })}
        confirmationText=""
        queryKey={queryKeys.listMemberships}
        successMessage={intl.formatMessage({
          id: "membership_deleted_successfully",
        })}
      />

      <HeadTable
        data={listMemberships?.data}
        deleteModal={deleteModal}
        search={search}
        setSearch={SearchInput}
        setDeleteModal={setDeleteModal}
        placeHolderSerch={intl.formatMessage({
          id: "search_membership_client",
        })}
        button={
          <Button
            type="primary"
            onClick={() => openModal("AddMembership")}
            icon={<BsPlusSquare />}
          >
            {intl.formatMessage({ id: "add_membership" })}
          </Button>
        }
      />
      <Spin size="large" spinning={isLoading}>
        {!isLoading &&
        listMemberships?.data &&
        listMemberships?.data.length > 0 ? (
          <AntTable
            tableColumns={columns}
            tableData={listMemberships?.data || []}
            isLoading={isLoading}
            hideArrowExpand
            rowData={(record: any) => (
              <MembershipRowData
                data={record}
                deleteRowData={() => showDeleteModal(record)}
                editRowData={() => openEditModal("EditMembership", record)}
              />
            )}
          />
        ) : !isLoading ? (
          <Empty
            title={intl.formatMessage({ id: "no_memberships_yet" })}
            subTitle={intl.formatMessage({ id: "add_membership_now" })}
            buttons={
              <div>
                <Button
                  onClick={() => openModal("AddMembership")}
                  className="border-none bg-[#EEF0FF] shadow-none outline-none text-[#75757E]"
                  icon={<PlusOutlined />}
                >
                  <FormattedMessage id="add_membership" />
                </Button>
              </div>
            }
          />
        ) : (
          <div className="h-[300px]"></div>
        )}
      </Spin>
    </div>
  );
};

export default MembershipTable;
